/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { Component, Injector } from '@angular/core';
import { DetailAbstract, UNPLACEHOLDER } from '@dm/core';
import { type Observable, of } from 'rxjs';

import { type CheckDetail, type UpgradeDetail, CmoDetailAtomState } from '../upgrade.const';
import { UpgradeStrService } from '../upgrade-str.service';

@Component({
    selector: 'app-upload-fail-detail',
    templateUrl: './upload-fail-detail.html',
    styleUrls: ['./upload-fail-detail.scss'],
})
export class UploadFailDetailComponent extends DetailAbstract<CheckDetail> {
    i18n = this.str.i18n;
    UNPLACEHOLDER = UNPLACEHOLDER;

    CmoDetailAtomState = CmoDetailAtomState;

    constructor(
        injector: Injector,
        public str: UpgradeStrService,
    ) {
        super(injector);
    }

    initOperationBtns(): void {
    }

    /**
     * 获取错误信息
     *
     * item 错误详情项
     */
    getErrorInfo = (item: UpgradeDetail): string => {
        // 暂停或失败会显示错误详情
        const errorDetail = item.CMO_DETAIL_ATOM_RECORD ?? this.i18n.failed;
        return `${item.CMO_DETAIL_NODE_ID} - ${item.CMO_STEP_NAME} - ${errorDetail}`;
    };

    getData(): Observable<any> {
        return of(this.data);
    }
}
